import React, { Component } from "react";
//import auth from "../services/authService";
//
import Table from "./common/table";
import Like from "./common/like";
import Lock from "./common/lock";
import Moment from "react-moment";
import TextArea from "./common/textArea";
//import { toast } from "react-toastify";
//import MessageCount from "./common/messageCount";
import TextareaAutosize from 'react-textarea-autosize';
import { isBlockedShortCode } from "../utils/shortCodeStatus";
import { appendQuickReply } from "../utils/quickReplies";
import CopyableText from "./common/copyableText";
class DreamsTableSearch extends Component {
  state = {
    // data: {
    //   correctWord: "",
    //   wrongWord: "",

    //   filedId: ""
    // },
    modalIsOpen: false,
    errors: {},
    dream: [],
    replyMsg: "",
    MT_Englsih: "",
    personStatus: "",

    disableSent: false,
  };

  // handleChange = ({ currentTarget: input }) => {
  //   // const errors = { ...this.state.errors };
  //   // const errorMessage = this.validateProperty(input);
  //   // if (errorMessage) errors[input.name] = errorMessage;
  //   // else delete errors[input.name];

  //   const data = { ...this.state.data };
  //   data[input.name] = input.value;

  //   if (input.name === "correctWord") {
  //     //let wrongWords={ ...this.props.wrongWords };

  //     data["filedId"] = input.id.replace("correctWord", "");
  //     let listOfWrongWords = this.props.wrongWords.filter(
  //       m => m.correctWords === input.value
  //     );
  //     let str = "";

  //     for (var i = 0; i < listOfWrongWords.length; i++) {
  //       if (listOfWrongWords.length - 1 === i) {
  //         str = str + listOfWrongWords[i]["wrongWords"];
  //       } else {
  //         str = str + listOfWrongWords[i]["wrongWords"] + "\n";
  //       }
  //     }

  //     data["wrongWord"] = str;
  //     ////console.log(data["wrongWord"] );
  //   } else if (input.name === "keyWords") {
  //     const tafseer = this.props.tafseer;

  //     data["filedId"] = input.id.replace("keyWords", "");

  //     var theremeaning = tafseer.filter(m => m.words === input.value);
  //     if (theremeaning.length > 0) {
  //       data["meaningWords"] = theremeaning[0].meaning;
  //     } else {
  //       data["meaningWords"] = "";
  //     }
  //   }

  //   this.setState({ data });
  // };

  handleChangeInput = (dream) => ({ currentTarget: input }) => {
    //   //  if(input.value.length < 10){
    //   // return  toast.error("الرسالة أقل من 10 حروف ");
    //   //  }
    ////console.log("Dream table " + input.name);

    // dream[input.name]=input.value;
    dream[input.name] = input.value;
    this.setState({ dream: dream });
    this.props.onChangeText(dream, input.name, input.value);
  };

  handleChangeInput1 = (dream) => ({ currentTarget: input }) => {
    //   //  if(input.value.length < 10){
    //   // return  toast.error("الرسالة أقل من 10 حروف ");
    //   //  }
    ////console.log("Dream table " + input.name);

    // dream[input.name]=input.value;
    dream[input.name] = input.value;
    this.setState({ dream: dream });
    this.props.onChangeText(dream, input.name, input.value);
  };

  handleGreeting = (e) => {
    //   //  if(input.value.length < 10){
    //   // return  toast.error("الرسالة أقل من 10 حروف ");
    //   //  }
    // e.preventDefault();
    ////console.log(e.currentTarget.textContent);
    // this.myRef.current.value =e.currentTarget.textContent  + " ";
    // this.setState({replyMsg  : e.currentTarget.textContent  + " "});
  };

  getReplyInputName = (dream) => {
    if (dream.MsgRegFroSend === 4) return "ReplyMsg4";
    if (dream.MsgRegFroSend === 1) return "MT_Reply_Msg";
    return "ReplyMsg" + (dream.MsgRegFroSend + 1);
  };

  getReplyInputValue = (dream) => {
    const name = this.getReplyInputName(dream);
    return dream[name] || "";
  };

  handleUseQuickContactReply = (dream) => {
    const name = this.getReplyInputName(dream);
    const nextMessage = appendQuickReply(dream[name]);
    dream[name] = nextMessage;
    this.setState({ dream });

    this.props.onChangeText(dream, name, nextMessage);
  };

  columns = [
    {
      path: "MT_Mobil",
      label: "المعلومات",
      content: (dream) => (
        <div
          className={
            dream.MOShortCode === 7570 || dream.MOShortCode === 4060
              ? "bg-warning text-dark"
              : "bg-light text-dark"
          }
        >
          {this.props.shouldHide ? (
            <div style={{ Padding: "15px" }}>
              <button
                type="button"
                className="btn btn-primary   btn-block"
                onClick={() => this.props.onGetAll(dream.MT_Mobil)}
              >
                رؤية كل شيء{" "}
              </button>
            </div>
          ) : (
            <div style={{ Padding: "15px" }}>
              <button
                type="button"
                className="btn btn-primary   btn-block"
                onClick={() => this.props.onUnLockAll(dream.MT_Mobil)}
              >
                عودة{" "}
              </button>
            </div>
          )}
          <br></br>{" "}
          <Like
            liked={dream.isprivate}
            onClick={() => this.props.onLike(dream)}
          />{" "}
          &nbsp;&nbsp;
          <Lock
            locked={dream.islock}
            onClick={() => this.props.onLock(dream)}
          />{" "}
          {/* onOpenModel */}
          <i
            onClick={() => this.props.onOpenModel(dream)}
            style={{ cursor: "pointer" }}
            className="fa fa-database fa-lg"
            aria-hidden="true"
          />
          {dream.islock ? (
            <Moment
              parse="YYYY-MM-DD HH:mm"
              format="YYYY-MM-DD hh:mm A"
              className="text-success"
            >
              {dream.userlockDate}
            </Moment>
          ) : (
            ""
          )}
          {"  "}
          {dream.Userlock}
          <br />
          <h4 className="text-primary">
            {" "}
            {dream.MOShortCode}{" "}
            {isBlockedShortCode(dream.MOShortCode) ? "❌" : "✅"}
          </h4>
          <br />
          {dream.ServicesName}
          <TextareaAutosize
            minRows={2}
            className={
              dream.MOShortCode === 7570
                ? "bg-warning text-dark"
                : "bg-light text-dark"
            }
            rows={2}
            id={"personStatus" + dream.ReplyID}
            name="personStatus"
            onChange={this.handleChangeInput(dream)}
            defaultValue={dream.PersonStatus}
          />
          {/* {dream.ReplyUserName}  
          
          {"  "} */}
          <CopyableText value={dream.MT_Mobil} />
          <br />
          <Moment
            parse="YYYY-MM-DD HH:mm"
            format="YYYY-MM-DD hh:mm A"
            className="text-primary"
          >
            {dream.MO_Date}
          </Moment>
          <br />
          <button
            type="button"
            onClick={() => this.handleUseQuickContactReply(dream)}
            className="btn btn-info btn-sm btn-block mb-2"
            disabled={
              dream.islock &&
              this.props.user !== dream.Userlock &&
              this.props.pcode !== 999
            }
            title="وضع نص التواصل داخل خانة الرد"
          >
            <i className="fa fa-commenting-o" aria-hidden="true" /> نص التواصل
          </button>
          {dream.isdelete ? (
            <button
              onClick={() => this.props.onDelete(dream)}
              className="btn btn-danger btn-sm btn-block"
            >
              إلغاء الحذف
            </button>
          ) : (
            <button
              onClick={() => this.props.onDelete(dream)}
              className="btn btn-danger btn-sm  btn-block"
            >
              حذف
            </button>
          )}
        </div>
      ),
    },

    {
      path: "MO_Message",
      label: "الرسالة",
      content: (dream) =>
        true ? (
          <div>
            {dream.isdelete ? (
              <div>
                {" "}
                <i className="fa fa-trash fa-5x text-danger"></i>{" "}
              </div>
            ) : (
              ""
            )}

            <div
              className={
                dream.MOShortCode === 4022
                  ? " text-right row4022color"
                  : dream.MOShortCode === 2337
                  ? "text-right text-primary"
                  : dream.MOShortCode === 6877
                  ? "text-right row6877color"
                  : dream.MOShortCode === 3900
                  ? "text-right row3900color"
                  : ""
              }
            >
              {" "}
              {dream.MOShortCode === 3900 ? (
                <div>
                  {" "}
                  {dream.MO_Message} +{" "}
                  <i
                    className="fa fa-snowflake-o fa-lg text-danger"
                    aria-hidden="true"
                  ></i>
                  <i className="fa fa-snowflake-o fa-lg" aria-hidden="true"></i>
                  <i className="fa fa-snowflake-o fa-lg" aria-hidden="true"></i>
                </div>
              ) : (
                dream.MO_Message
              )}
            </div>

            <div className="text-right text-success">{dream.MT_Reply_Msg}</div>
            <div className="text-right text-info">{dream.ReplyMsg2}</div>
            <div className="text-right text-warning">{dream.ReplyMsg3}</div>
            <div className="text-right text-dark">{dream.ReplyMsg4}</div>
           
            <br></br>
            <TextareaAutosize
              minRows={4}
              className="form-control"
              style={{ direction: "rtl" }}
              rows={4}
              id={"MT_Reply_Msg" + dream.ReplyID}
              name={this.getReplyInputName(dream)}
              value={this.getReplyInputValue(dream)}
              onChange={this.handleChangeInput(dream)}
              placeholder={"اكتب الرد " + (dream.MsgRegFroSend + 1)}
            />
            {this.state.dream["ReplyID"] === dream.ReplyID ? (
              <div className="form-group">
                <span className="label label-primary">
                  عدد الحروف{" "}
                  {dream["MT_Reply_Msg"] ? dream["MT_Reply_Msg"].length : 0} -
                  عدد الرسائل{" "}
                  {dream["MT_Reply_Msg"] && dream["MT_Reply_Msg"].length < 71
                    ? 1
                    : Math.ceil(
                        dream["MT_Reply_Msg"]
                          ? dream["MT_Reply_Msg"].length / 63
                          : 0,
                      )}
                </span>
              </div>
            ) : (
              ""
            )}

            <button
              onClick={() => this.props.onSendMsg(dream)}
              className="btn text-right btn-success btn-sm"
            >
              ارسال
            </button>
          </div>
        ) : (
          <TextArea dream={dream} {...this.props} />
        ),
    },
  ];

  render() {
    const { dreams, onSort, sortColumn } = this.props;

    return (
      <Table
        columns={this.columns}
        data={dreams}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default DreamsTableSearch;



// WEBPACK FOOTER //
// ./src/components/dreamsTableSearch.jsx